<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content">
	<div>
		<copo-submission-feedback></copo-submission-feedback>
	</div>
	<copo-panel-header [ngClass]="isSaveAsDraftBtnDisable || readOnlyUser ? '' : 'copo-panel-header'" [isBackButtonVisible]="true" (backButtonClick)="goToBackView()" [titleHeaderText]="pageTitle">
		<button type="button" mat-flat-button *ngIf="!isLoading && getCurrentStatus()"
			[ngClass]="isSaveAsDraftBtnDisable || readOnlyUser ? 'save-button-disable' : ''" (click)="evtSaveDraftOrder()">
			<span translate>eorder.action.save.draft</span>
			<mat-icon class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button *ngIf="!isLoading && isButtonViewCardVisible()" type="submit" mat-flat-button color="primary" (click)="goNextStep()">
			<span translate>action.viewcart</span>
			<span *ngIf="getProductCount() > 0">&nbsp;({{getProductCount()}})</span>
		</button>
		<button *ngIf="!isLoading && isButtonNextVisible()" type="submit" mat-flat-button color="primary"
			[disabled]="(isButtonDisabled() === true || isButtonDisabled() === undefined)"
			(click)="goNextStep()">
			<span translate>eorder.action.next</span>
		</button>
		<button *ngIf="!isLoading && isButtonSubmitVisible()" type="submit" mat-flat-button color="primary"
			[disabled]="readOnlyUser || isConfirmDisabled" (click)="evtSubmitEorder()">
			<span translate>need4steel.wizard.summary.confirm.to.order.button</span>
		</button>
	</copo-panel-header>
	<copo-legal-document-agreement class="font-family-summary" *ngIf="isButtonSubmitVisible()" [legalDocumentLabel]="legalDocumentLabel" [serviceCode]="serviceCode" (userAgreementCheck)="onUserAgreementCheck($event)"></copo-legal-document-agreement>
	<div class="copo-wizzard-stepper-container">
		<copo-eorder-wizard-stepper *ngIf="getCurrentStatus()"></copo-eorder-wizard-stepper>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<router-outlet
			*ngIf="!isLoading; else loading"
			(activate)="onActivate($event)"
			(deactivate)="onDeactivate()"
			copoAfterViewInit
			(afterviewinit)="scroller.restoreState()"
		></router-outlet>
	</div>
</div>